import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import DashboardWrapper from '../Dashboard/components/DashboardWrapper'
import InnerBanner from '../../components/InnerBanner'
import Loader from '../../components/Loader'
import ContractPreviewSection from '../../components/ContractPreviewSection/ContractPreviewSection'
import { PRIVATE_ROUTES } from '../../Routes/routes'
import { useGetProfileUserInfo } from '../../hooks/useGetProfileUserInfo'
import { getCompanyInformation } from '../../services/CompanyData'
import { getCompanyContracts } from '../../services/NewServicesCompnay'
import { TAGS } from '../../services/Tags'

const CompanyContract = () => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const { data: profileUserData = {}, isLoading: isLoadingProfile } =
    useGetProfileUserInfo()

  const { userInfo = {} } = profileUserData || {}
  const companyId = userInfo?.id

  const { isLoading: isLoadingCompany } = useQuery({
    queryKey: [TAGS.company_detail, companyId],
    queryFn: () => getCompanyInformation(companyId),
    enabled: !!companyId,
  })

  const { data: contractsData, isLoading: isLoadingContracts } = useQuery({
    queryKey: ['company-contracts', 0],
    queryFn: () => getCompanyContracts(0),
  })

  const contracts = contractsData?.res?.list ?? []
  const currentContract = contracts[currentIndex] ?? null
  const sig = currentContract?.contract_signature ?? {}

  const isLoading = isLoadingProfile || (!!companyId && isLoadingCompany) || isLoadingContracts

  const handleIndexChange = (next) => {
    if (next < 0 || next >= contracts.length) return
    setCurrentIndex(next)
  }

  return (
    <DashboardWrapper dashboardWrapperClassName="w-100 flex-grow-1">
      <div className="p-3 p-lg-4 w-100">
        <InnerBanner
          before="Inicio"
          beforeRoute={PRIVATE_ROUTES.dashboard}
          text="Contrato"
          className="mb-3"
        />

        {isLoading ? (
          <div className="d-flex justify-content-center py-5">
            <Loader />
          </div>
        ) : contracts.length === 0 ? (
          <p className="text-on-bg-secondary mb-0" style={{ fontSize: 14 }}>
            No hay contratos disponibles en este momento.
          </p>
        ) : (
          <ContractPreviewSection
            contract={currentContract}
            finalPdfUrl={sig.final_pdf_url}
            initialDocxUrl={sig.initial_pdf_url}
            contractStatus={currentContract?.contract_status?.name}
            contractsTotal={contracts.length}
            contractsCurrent={currentIndex}
            onContractChange={handleIndexChange}
          />
        )}
      </div>
    </DashboardWrapper>
  )
}

export default CompanyContract
